import cn from 'classnames';
import React, {FC} from 'react';

import styles from './Button.module.scss';
import ButtonArrowEnterSVG from './ButtonArrowEnterSVG/ButtonArrowEnterSVG';
import ButtonArrowSVG from './ButtonArrowSVG/ButtonArrowSVG';
import ButtonRaw from './ButtonRaw';
import {IButton} from './ButtonTypes';

const Button: FC<IButton> = ({showArrow, showEnterArrow, children, arrowClassName, className, ...props}) => {
    return (
        <ButtonRaw {...props} className={cn(styles.Button, className)}>
            {children}
            {showArrow && <ButtonArrowSVG arrowClassName={arrowClassName} />}
            {showEnterArrow && <ButtonArrowEnterSVG />}
        </ButtonRaw>
    );
};

export default Button;
